import React from 'react';
import Head from 'next/head';
import { GetStaticProps } from 'next';
import { useTranslation } from 'react-i18next';
import { useWebPageGraph } from '../../../components/structuredData/useWepPageGraph';
import { Layout } from '../../../components/onvista/Layout';
import { useFAQ } from '../../../components/structuredData/useFAQ';
import { OnvistaCashbackCalculator } from '../../../features/cashbackCalculator/OnvistaCashbackCalculator';

export default function FondsCommissionCalculatorPage() {
  const { t } = useTranslation();
  const faqLdJson = useFAQ();
  const webPageLdJson = useWebPageGraph(
    t('cashbackCalculator.title'),
    t('cashbackCalculator.description')
  );

  return (
    <Layout home>
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(faqLdJson),
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(webPageLdJson),
          }}
        />
        <title>{t('cashbackCalculator.title')}</title>
        <meta name="language" content="deutsch, de" />
        <meta name="robots" content="noodp,index,follow" />

        <meta name="keywords" content={t('cashbackCalculator.keywords')} />
        <meta name="description" content={t('cashbackCalculator.description')} />
        <meta name="page-topic" content={t('cashbackCalculator.pageTopics')} />

        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://rentablo.de/onvista-cashback/fonds-provisionsrechner"
        />
        <meta property="og:title" content={t('cashbackCalculator.title')} />
        <meta property="og:site_name" content={t('cashbackCalculator.title')} />
        <meta
          property="og:image"
          content="https://rentablo.de/images/sharing/rentablo-cashback.jpg"
        />
        <meta
          property="og:image"
          content="https://rentablo.de/images/sharing/rentablo-cashback-explanation.jpg"
        />
        <meta property="og:image" content="https://rentablo.de/images/rentablo-logo-white.svg" />
        <meta property="og:image" content="https://rentablo.de/images/rentablo-phone.jpg" />
        <meta property="og:image" content="https://rentablo.de/images/rentablo-mobile.jpg" />
        <meta property="og:description" content={t('cashbackCalculator.description')} />
        <link rel="canonical" href="https://rentablo.de/fonds-provisionsrechner" />
      </Head>
      <OnvistaCashbackCalculator />
    </Layout>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {},
  };
};
